<template>
    <div class="lead">
        <v-expansion-panels flat :key="leadToChange.code_lead" class="itemLead" outlined>
                <v-expansion-panel >
                    <v-expansion-panel-header>
                        <div class="headingLead">
                            <h3>{{leadToChange.prenom}} {{leadToChange.nom}}</h3>
                            <div class="subLead">
                                <div v-if="mode=='lead'">
                                    {{leadToChange.code_lead}} 
                                    <span v-if="leadToChange.telephone_mobile == ''">{{leadToChange.telephone_fixe}}</span>
                                    <span v-if="leadToChange.telephone_mobile != ''">{{leadToChange.telephone_mobile}}</span>
                                </div>
                                <div v-if="mode =='rdv'" class="rdv">
                                    <i class="mdi mdi-clock-outline "></i>{{heure_rdv}}
                                </div>
                                <span class="status" :class="this.lead.finalStatut" v-if="!leadToChange.finalSubStatut || leadToChange.finalSubStatut.length == 0">{{status}}</span>
                                <span class="subStatus" v-if="leadToChange.finalSubStatut && leadToChange.finalSubStatut.length > 0">
                                    <span class="sub" v-for="substatut in leadToChange.finalSubStatut" :key="substatut" :class="substatut">
                                        {{$t('messages.statuts.'+substatut)}}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-divider></v-divider>
                        <v-row dense class="mt-2 justify-space-around">
                            <v-col v-if="rdv.date_rendez_vous && mode == 'lead'" cols="6" class="rdvDisplay">
                                <i class="mdi mdi-calendar"></i>{{date_rdv}}
                            </v-col>
                            <v-col v-if="rdv.date_rendez_vous && mode == 'lead'" cols="6" class="rdvDisplay">
                                <i class="mdi mdi-clock-outline "></i>{{heure_rdv}}
                            </v-col>
                            <v-col cols="4" class="text-center">
                                <v-btn rounded color="primary" outlined depressed @click="goToDetail">{{$t('messages.todo.detail')}}</v-btn>
                            </v-col>
                            <v-col cols="4" class="text-center">
                                <v-btn v-if="phone" :href="`tel:${phone}`" rounded color="primary" outlined depressed>{{$t('messages.todo.appeler')}}</v-btn>
                            </v-col>
                            <v-col cols="4" v-if="PhysiqueValue == false">
                                <v-btn :href="visioLink" rounded color="primary" outlined depressed>Visio</v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-container>
                                    <v-row dense v-if="leadToChange.finalStatut == 'rdvaConfirmer'">
                                        <v-col cols="12" class="text-center" v-if="!confirm">
                                            <v-btn depressed rounded color="primary" @click="confirm = !confirm">
                                                Confirmer le RDV
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="leadToChange.finalStatut == 'rdvaConfirmer'">
                                        <v-col cols="12" class="text-center confirmContent" v-if="confirm">
                                            <p class="confirmMsg">La confirmation de RDV est irréversible, Êtes-vous sûr ?</p>
                                            <v-btn depressed rounded color="grey" dark @click="confirm = !confirm">
                                                Non
                                            </v-btn>
                                            <v-btn depressed rounded color="primary" @click="confirmRdv">
                                                Oui
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-col>
                            <v-col cols="12"  v-if="rdv.id && leadToChange.finalStatut != 'rdvaConfirmer'">
                                <v-row dense>
                                    <v-col cols="12" class="text-center">
                                        <v-btn-toggle    
                                        v-model="PhysiqueValue"                          
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            
                                            <v-btn :value="valueFalse">
                                                Rdv Visio
                                            </v-btn>
                                            <v-btn :value="valueTrue">
                                                Rdv Physique
                                            </v-btn>
                                            <v-btn :value="valueNull">
                                                N/C
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                    <v-col cols="6" class="text-left question">
                                    {{$t('messages.todo.venu')}}
                                    </v-col>
                                    <v-col cols="6">
                                        <v-btn-toggle    
                                        v-model="venuValue"                          
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            <v-btn :value="valueNull">
                                                {{$t('messages.todo.nc')}}
                                            </v-btn>
                                            <v-btn :value="valueTrue">
                                                {{$t('messages.todo.oui')}}
                                            </v-btn>
                                            <v-btn :value="valueFalse">
                                                {{$t('messages.todo.non')}}
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                    <v-col v-show="venuValue === true" cols="6" class="text-left question">
                                    {{$t('messages.todo.vendu')}}
                                    </v-col>
                                    <v-col v-show="venuValue === true" cols="6">
                                        <v-btn-toggle   
                                        v-model="venduValue"                           
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            <v-btn :value="valueNull">
                                                {{$t('messages.todo.nc')}}
                                            </v-btn>
                                            <v-btn :value="valueTrue">
                                                {{$t('messages.todo.oui')}}
                                            </v-btn>
                                            <v-btn :value="valueFalse">
                                                {{$t('messages.todo.non')}}
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                    <v-col v-show="venduValue === true" cols="5" class="text-left question">
                                    Type de vente
                                    </v-col>
                                    <v-col v-show="venduValue === true" cols="7">
                                        <v-btn-toggle   
                                        v-model="typeValue"                           
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            <v-btn :value="valueNull">
                                                NC
                                            </v-btn>
                                            <v-btn value="VN">
                                                VN
                                            </v-btn>
                                            <v-btn value="VO">
                                                VO
                                            </v-btn>
                                            <v-btn value="VD">
                                                VD
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                    <v-col v-show="typeValue !== valueNull" cols="5" class="text-left question">
                                    Financement
                                    </v-col>
                                    <v-col v-show="typeValue !== valueNull" cols="7">
                                        <v-btn-toggle   
                                        v-model="financementValue"                           
                                        tile
                                        color="primary"
                                        dense
                                        mandatory
                                        group
                                        @change="changeLead"
                                        >
                                            <v-btn :value="valueNull">
                                                {{$t('messages.todo.nc')}}
                                            </v-btn>
                                            <v-btn :value="valueTrue">
                                                {{$t('messages.todo.oui')}}
                                            </v-btn>
                                            <v-btn :value="valueFalse">
                                                {{$t('messages.todo.non')}}
                                            </v-btn>
                                        </v-btn-toggle>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            
    </div>
</template>
<script>
export default {
    props: ['lead', 'code', 'mode'],
    data() {
        return {
            valueNull : -1,
            valueTrue : true,
            valueFalse : false,
            leadToChange: {},
            venuValue: "",
            venduValue : "",
            typeValue: "",
            financementValue: "",
            PhysiqueValue: "",
            rdv:{},
            confirm:false,
        }
    },
    computed: {
        visioLink: function(){
            return "https://rdv-visio.fr/uys_"+this.lead.code_lead
        },
        phone: function(){
            if(this.leadToChange.telephone_mobile != ""){
                return this.leadToChange.telephone_mobile
            } else if (this.leadToChange.telephone_fixe != ""){
                return this.leadToChange.telephone_fixe
            } else {
                return ""
            }
        },
        status: function() {
            switch (this.lead.finalStatut) {
                case "echec":
                    return this.$t('messages.statuts.echec')
                    break;
                case "passage":
                    return this.$t('messages.statuts.passage')
                break;
                case "rdvQualifier":
                    return this.$t('messages.statuts.rdvQualifier')
                break;
                case "rdvaQualifier":
                    return this.$t('messages.statuts.rdvaQualifier')
                break;
                case "nouveau":
                    return this.$t('messages.statuts.nouveau')
                break;
                case "rdvaConfirmer":
                    return this.$t('messages.statuts.rdvaConfirmer')
                break;
                case "ARLP":
                    return this.$t('messages.statuts.ARLP')
                break;
                case "ARRP":
                    return this.$t('messages.statuts.ARRP')
                break;
                case "wait":
                    return this.$t('messages.statuts.wait')
                break;
                case "black":
                    return this.$t('messages.statuts.black')
                break;
            }
        },
        date_rdv: function() {
            if(this.rdv.date_rendez_vous){
                const dateRdv = this.rdv.date_rendez_vous.split(" ");
                return dateRdv[0];
            } else {
                return "N/C";
            }
        },
        heure_rdv: function() {
            if(this.rdv.date_rendez_vous){
                const dateRdv = this.rdv.date_rendez_vous.split(" ");
                return dateRdv[1];
            } else {
                return "N/C";
            }
        }
    },
    watch: {
        venuValue: function(val) {
            if(val == false){
               this.venduValue = false 
            }
            if(this.rdv.id){
                this.rdv.venu = val
            }
        },
        venduValue: function(val) {
            if(val == false){
               this.typeValue = false 
            }
            if(this.rdv.id){
                this.rdv.vendu = val
            }
        },
        typeValue: function(val) {
            if(this.rdv.id){
                this.rdv.type_vente = val
            }
        },
        financementValue: function(val) {
            if(this.rdv.id){
                this.rdv.financement = val
            }
        },
        PhysiqueValue: function(val) {
            if(this.rdv.id){
                this.rdv.est_physique = val
            }
        },
        rdv: function(val){
            this.leadToChange.rdv.splice(0, 1)
            this.leadToChange.rdv.unshift(val)
        },
        leadToChange: {
            deep: true,
            handler(lead){
                if(lead.rdv[0] 
                && lead.rdv[0].venu !== null 
                && lead.rdv[0].vendu !== null 
                && lead.rdv[0].type_vente !== null 
                && lead.rdv[0].financement !== null
                && lead.rdv[0].venu !== -1 
                && lead.rdv[0].vendu !== -1 
                && lead.rdv[0].type_vente !== -1
                && lead.rdv[0].financement !== -1){
                    this.$emit('qualifiedLead');
                    this.$emit('reloadLeads');
                }
            }
            
        }
    },
    methods: {
        confirmRdv: function() {
            this.leadToChange.rdv[0].confirme = true;
            this.$store.dispatch('setLoader', true).then((e) => {
                this.$store.dispatch('changeLead', this.leadToChange).then((e)=> {
                    let rdvPayload = {
                    id_rendez_vous: this.rdv.id,
                    id_utilisateur: this.leadToChange.id,
                    data:
                        {
                            est_confirme: "OUI",
                        }
                    }
                    this.$store.dispatch('updateRdv', rdvPayload).then((e) => {
                        this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e) => {
                            this.$emit('reloadLeads');
                            this.$nextTick(() => {
                                this.leadToChange = Object.assign({}, this.lead)
                                this.$store.dispatch('setLoader', false)
                            })
                        })
                    })
                })
            }) 
        },
        goToDetail: function() {
            this.$store.dispatch('getDetailLead', this.lead.code_lead).then(() => {
                this.$router.push({ name: 'Details', params: { code: this.code, id: this.lead.id } })
            })
        },
        changeLead: function() {
            this.$store.dispatch('changeLead', this.leadToChange).then((e) => {
                let rdvPayload = {
                    id_rendez_vous: this.rdv.id,
                    id_utilisateur: this.leadToChange.id,
                    data:
                        {
                            nb_pass: this.rdv.nb_personnes,
                            commentaire: this.rdv.commentaire,
                            est_venu: this.rdv.venu,
                            avec_vente: this.rdv.vendu,
                            VN_VO_VD: this.rdv.type_vente,
                            est_physique: this.rdv.est_physique,
                            financement: this.rdv.financement
                        }
                }
                this.$store.dispatch('updateRdv', rdvPayload).then((e) => {
                    this.$store.dispatch('setStatut', this.leadToChange)
                })
            })
        }
    },
    created() {
        this.leadToChange = Object.assign({}, this.lead)
        if(this.leadToChange.rdv[0]){
            this.rdv = this.leadToChange.rdv[0]
            this.venuValue = this.leadToChange.rdv[0].venu
            this.venduValue = this.leadToChange.rdv[0].vendu
            this.typeValue = this.leadToChange.rdv[0].type_vente
            this.financementValue = this.leadToChange.rdv[0].financement
            this.PhysiqueValue = this.leadToChange.rdv[0].est_physique
        } else {
            this.PhysiqueValue = -1
        }
        
        
    },
}
</script>
<style lang="scss">
    .lead {
        .itemLead {
            padding:5px 10px;
            .v-expansion-panel-header {
                padding: 16px 10px;
            }
            .v-expansion-panel-content__wrap {
                padding: 0 10px 16px;
            }
            .headingLead {
                font-size:0.9em;
                 h3 {
                    margin-bottom:10px;
                    letter-spacing: -1px;
                }
                div {
                    font-style: italic;
                }
                .rdv {
                    font-style: normal;
                    font-size:1.4em;
                    display:flex;
                    align-items: center;
                }
            }
           .question {
               display:flex;
               align-items: center;
                font-size:0.9em;
           }
           .v-btn-toggle--group {
               .v-btn__content {
                    font-size: 0.9em;
                }
           }
           
        }
        .headingLead {
            .subLead {
                display:flex;
                align-items: center;
                justify-content: space-between;
            }
            .status {
                padding:5px;
                background-color: orange;
                color:#FFF;
                border-radius:3px;
                &.echec {
                    background-color: red;
                }
                &.black {
                    background-color: #000;
                }
            }
            .subStatus {
                padding:5px;
                .sub {
                    padding:3px;
                    color:#FFF;
                    border-radius:3px;
                    &.venu, &.achat, &.achat_vo, &.achat_vn, &.achat_vd {
                        background-color: green;
                    }
                    &.novenu, &.noachat {
                        background-color: red;
                    }
                    &.venu, &.novenu {
                        margin-right:5px;
                    }
                }
            }
        }
        .rdvDisplay {
            display:flex;
            align-items: center;
        }
        .mdi-calendar, .mdi-clock-outline {
            font-size:1.5em;
            margin-right:5px;
            color: #081525;
        }
        .confirmContent{
            border: 1px solid #eb566b;
            border-radius:10px;
            .v-btn {
                margin: 0 40px;
            }
        }
        .confirmMsg {
            margin: 0 auto;
            margin-bottom:10px;
            font-weight:700;
        }
    }
</style>